"use client"

import { extractBlockProperties } from "@/utils/simplifyData"
import styled from "@emotion/styled"
import { Box } from "@mui/material"
import "swiper/css"
import { mediaQueries } from "ui/theme/mediaQueries"
import SwiperOnMobile from "../SwiperOnMobile/SwiperOnMobile"
import ActionLinkCardSelector from "../common/ActionLinkCardSelector"
import BlockWrapper from "../common/BlockWrapper"
import DetailsCard from "../common/DetailsCard"
import CommonTitle from "../common/bit/CommonTitle"
import { Desktop, Mobile } from "../common/bit/MediaQueries"
import { sizes } from "../theme/theme"
const bwSizes = sizes.BlockWrapper

const StyledBlockWrapper = styled(BlockWrapper)`
  display: flex;
  flex-direction: column;
  ${mediaQueries.desktopM} {
  }
  ${mediaQueries.desktopXl} {
    padding-inline-start: ${bwSizes.desktopXl.padding};
    padding-inline-end: ${bwSizes.desktopXl.padding};
  }
`

const StyledCard = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  gap: ${sizes.basePenta};
  align-self: stretch;
  border-radius: ${sizes.borderRadiusLarge};
  ${mediaQueries.desktopM} {
    padding: 0 ${sizes.baseTriple};
  }
  ${mediaQueries.desktop} {
    padding: 0;
  }
`

const StyledDetailsCard = styled(DetailsCard)`
  width: 100%;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: -16px 20px 60px 0px rgba(2, 1, 64, 0.12);
  backdrop-filter: blur(15px);
`
const StyledActionLinkCardSelector = styled(ActionLinkCardSelector)`
  gap: 0;
  .action-link-card-selector {
    ${mediaQueries.desktopM} {
      width: 70%;
    }
    ${mediaQueries.desktopXl} {
      width: 77%;
    }
  }
`

const CardsWithInternalTextRelated = ({
  id,
  data,
}: {
  data: any
  id?: string
}) => {
  const {
    title,
    itemsList,
    addressIcon,
    emailIcon,
    faxIcon,
    phoneIcon,
    whatsappIcon,
  } = data
  const itemsListBlocks = extractBlockProperties(itemsList?.blocks)
  const icons = {
    address: addressIcon?.mediaItems[0]?.url,
    email: emailIcon?.mediaItems[0]?.url,
    fax: faxIcon?.mediaItems[0]?.url,
    phone: phoneIcon?.mediaItems[0]?.url,
    whatsapp: whatsappIcon?.mediaItems[0]?.url,
  }
  return (
    <StyledBlockWrapper id={id}>
      <Desktop>
        <StyledCard>
          {title && (
            <CommonTitle
              additionalStylesWrapper={{
                alignItems: "flex-start",
                width: "100%",
              }}
            >
              {title?.value}
            </CommonTitle>
          )}
          <StyledActionLinkCardSelector
            itemsList={itemsList}
            icons={icons}
            isIconInTitle={false}
            smallDesktopCardWidth="230px"
            desktopCardWidth="234px"
          />
        </StyledCard>
      </Desktop>
      <Mobile>
        <SwiperOnMobile
          arrowIconName="arrow_lightPink_black_line"
          swiperProps={{
            slidesPerView: 1,
            slidesPerGroup: 1,
            navigation: true,
            loop: false,
            centeredSlides: false,
          }}
        >
          {itemsListBlocks.map((item: any, index: number) => {
            const {
              title,
              address,
              phone,
              email,
              fax,
              additionalPhone,
              whatsapp,
              itemsList,
              icon,
              primaryColor,
            } = item
            return (
              <StyledDetailsCard
                key={`investment-type-${index}`}
                data={{
                  title: title,
                  itemsList: itemsList,
                  icon: icon?.src,
                  detailsContent: [
                    {
                      ...phone,
                      additional: { ...additionalPhone },
                      icon: phoneIcon?.mediaItems[0]?.url,
                    },
                    {
                      ...whatsapp,
                      icon: whatsappIcon?.mediaItems[0]?.url,
                    },
                    { ...fax, icon: faxIcon?.mediaItems[0]?.url },
                    {
                      ...email,
                      icon: emailIcon?.mediaItems[0]?.url,
                    },
                    {
                      ...address,
                      icon: addressIcon?.mediaItems[0]?.url,
                    },
                  ],
                  primaryColor: primaryColor || "transparent",
                }}
              />
            )
          })}
        </SwiperOnMobile>
      </Mobile>
    </StyledBlockWrapper>
  )
}

export default CardsWithInternalTextRelated
